var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(this.title))]),_c('v-rating',{attrs:{"readonly":"","value":_vm.proficiency,"full-icon":"mdi-circle","empty-icon":"mdi-circle-outline","length":"5","size":"15px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }